import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div data-test-step-preview>\n  {{yield}}\n</div>\n",{ moduleName: "client-portal/components/request/steps/step-preview.hbs" })